import { jsonDelete, jsonGet, jsonPatch, jsonPost, jsonPut } from "../api";

export const fetchPrompts = async (brandId) =>
  await jsonGet(`brands/${brandId}/prompts`);

export const fetchPromptById = async (promptId) =>
  await jsonGet(`prompts/${promptId}`);

export const createPrompt = async (promptData) =>
  await jsonPost("prompts", promptData);

export const updatePrompt = async (promptId, promptData) =>
  await jsonPut(`prompts/${promptId}`, promptData);

export const deletePrompt = async (promptId) =>
  await jsonDelete(`prompts/${promptId}`);

export const detectPrompts = async (dto) =>
  await jsonPost("prompts/autodetect", dto);

export const measurePromptAwareness = async (promptId) =>
  await jsonPost(`prompts/${promptId}/awareness`);

export const updatePromptActive = async (promptId, status) =>
  await jsonPatch(`prompts/${promptId}/active`, { status });

export const suggestPrompts = async (brandId) =>
  await jsonPost(`brands/${brandId}/prompts/suggest`);

export const batchCreatePrompts = async (brandId, prompts) =>
  await jsonPost(`brands/${brandId}/prompts/batch`, prompts);

/**
 * Rewrites this brand's prompts into the language of the market it monitors.
 *
 * Enqueues a job and returns immediately — the rewrite is an LLM call per batch of prompts, and
 * the wording it writes is what every future measurement is taken with.
 */
export const localizePrompts = async (brandId) =>
  await jsonPost(`brands/${brandId}/prompts/localization`);
